<template>
  <div class="container-fluid">
    <div class="d-flex justify-content-between mb-3 align-items-center">
      <div>
        <div class="h3 font-weight-bold my-0">
          {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
        <div class="text-muted my-0">
          <span class="text-primary">Home</span> / {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div class="mr-2">
          <div class="mt-4 mt-md-0">
            <div class="btn-group ml-1" ref="filterButton">
              <button type="button" class="btn btn-white-primary" @click="toggleFilter" value="all">{{$t('application.all')}}</button>
              <button type="button" class="btn btn-white-primary" @click="toggleFilter" value="active">
                Active
              </button>
              <button type="button" class="btn btn-white-primary" @click="toggleFilter" value="inactive">
                Inactive
              </button>
            </div>
          </div>
        </div>
        <div>
          <button
          class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0"
          @click="onShowCreate"
          v-if="role_modules.some(item => item.value == 'company.create')"
        >
          <i class="uil-plus mr-1"></i> {{ $t('company.action.create_record') }}
        </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xl-12">
        <DataTable @onClick="onClickRefs" @onActivate="onActivate" ref="list" :type.sync="type" />
      </div>
    </div>
    <OffCanvas
      customBtnClass="component-custom"
      reload
      centered
      title="Update Company"
      size="xl"
      :buttonDisable="updated"
      ref="updateCompany"
      yesText="Update"
      noText="Cancel"
      :parameters="{ rowId, submitted }"
      :component="updateComponent"
      @onYes="onUpdateCompany"
      v-if="role_modules.some(item => item.value == 'company.edit')"
    />
    <OffCanvas
      customBtnClass="component-custom"
      centered
      is_reset_model
      title="Create Company"
      size="xl"
      ref="createCompany"
      yesText="Create"
      noText="Cancel"
      :buttonDisable="created"
      :parameters="{ submitted }"
      :component="createComponent"
      @onYes="onCreateCompany"
      v-if="role_modules.some(item => item.value == 'company.create')"
    />
    <OffCanvas
      autoload
      centered
      title="Company"
      size="xl"
      ref="viewCompany"
      bodyClass="modalBodyContainer px-4"
      :parameters="{ submitted, rowId }"
      :component="viewComponent"
      @onClick="onClickActions"
      v-if="role_modules.some(item => item.value == 'company.view')"
    />
    <Dialog
      autoload
      centered
      :titleHtml="'<i class=\'uil-trash mr-1\'></i> Confirmation'"
      size="md"
      ref="deleteCompany"
      yesText="Delete"
      noText="Cancel"
      :buttonDisable="deleted"
      :parameters="{ submitted, rowId }"
      :component="deleteComponent"
      @onYes="onDeleteCompany"
      v-if="role_modules.some(item => item.value == 'company.delete')"
    />
  </div>
</template>

<script>
import DataTable from '@common/datatable3'
import Dialog from '@components/dialogs'
import OffCanvas from '@components/offcanvas'
import CreateComponent from './components/dialogs/create.vue'
import UpdateComponent from './components/dialogs/edit.vue'
import ViewComponent from './components/dialogs/view.vue'
import DeleteComponent from './components/dialogs/delete.vue'

import error from '@utils/error'

const _types = {
  all:0,
  active:1,
  inactive:2,
}

export default {
  components: {
    DataTable,
    Dialog,
    OffCanvas
  },
  computed: {
    createComponent() {
      return CreateComponent
    },
    updateComponent() {
      return UpdateComponent
    },
    viewComponent() {
      return ViewComponent
    },
    deleteComponent() {
      return DeleteComponent
    },
  },
  data () {
    return {
      submitted: false,
      rowId: '',
      created: false,
      updated: false,
      deleted: false,
      type: 'active'
    }
  },
  methods: {
    onClickActions(val) {
      if (val && val.type && val.data) {
        if (val.type == 'function') {
          this[val.method](val.data)
        }
        else if (val.type == 'modal') {
          this.rowId = val.data.id ? val.data.id : val.data._id ? val.data._id : ''
          this.$refs[val.method].show()
        }
      }
    },
    syncData(){
      this.$refs.list.syncCompanies()
    },
    onShowCreate() {
      this.$refs.createCompany.show()
    },
    onClickRefs(val) {
      if (val && Object.entries(val).length) {
        this.rowId = val.val._id ? val.val._id : val.val.id ? val.val.id : val
        this.$refs[val.ref].show()
      }
    },
    onSendLink(val) {
      this.$bvModal.msgBoxConfirm('Please confirm that you want to send link to the company(this will use company email and will be sending a temporary link for company view).', {
        titleHtml: '<i class="uil uil-exclamation-triangle text-warning"></i> Please Confirm Action',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitleHtml: '<i class="uil uil-message"></i> SEND LINK',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        if(res == true){
          let id = val._id ? val._id : val.id ? val.id : this.rowId
          this.$store.dispatch('company/sendLink', { id })
          .then(res => {
            if(res.data.success){
              this.$bvToast.toast(`Successfully sent to the company!`, {
                title: 'Notification',
                variant:'success'
              })
            }
          })
        }
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
    onCreateCompany(val) {
      this.created = true
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      const objParam = ['industry_id', 'function_id', 'rate', 'source_company']

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.created = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      } else {
        model.brand_id = model && typeof model.brand_id == 'object' ? model.brand_id._id : model.brand_id
        model.timezone_id = model && typeof model.timezone_id == 'object' ? model.timezone_id._id : model.timezone_id
      }

      
      if (model && model.avatar_path) {
        let data = { ...model }
        model = new FormData()

        for (let key in data) {
          if (objParam.includes(key)) model.append(key, JSON.stringify(data[key]))
          else model.append(key, data[key])
        }
      }

      return this.$store.dispatch('company/create', model)
      .then(result => {
        if (result && result.data) {
          this.submitted = !this.submitted
          this.$refs.createCompany.hide()
          this.$refs.list.fetchData()
          this.$bvToast.toast(`${result.data.name} successfully created!`, {
            title: "Notification",
            variant: "success"
          })
          setTimeout(() => {
            this.created = false
          }, 1500)
        }
      })
      .catch(err => {
        this.created = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    onUpdateCompany(val) {
      this.updated = true
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      const objParam = ['industry_id', 'function_id', 'rate', 'source_company']

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.updated = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      } else {
        model.brand_id = model && typeof model.brand_id == 'object' ? model.brand_id._id : model.brand_id
        model.timezone_id = model && typeof model.timezone_id == 'object' ? model.timezone_id._id : model.timezone_id
      }
      
      if (model && model.avatar_path && typeof model.avatar_path == 'object') {
        let data = { ...model }
        model = new FormData()

        for (let key in data) {
          if (objParam.includes(key)) model.append(key, JSON.stringify(data[key]))
          else model.append(key, data[key])
        }
      }

      model.id = val.model._id ? val.model._id : val.model.id ? val.model.id : ''
      return this.$store.dispatch('company/update', model)
      .then(result => {
        if (result && result.data) {
          this.$refs.updateCompany.hide()
          this.$refs.list.fetchData()
          this.submitted = !this.submitted
          this.$bvToast.toast(`${result.data.name} successfully updated!`, {
            title: "Notification",
            variant: "success"
          })
          setTimeout(() => {
            this.updated = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.updated = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    onDeleteCompany(val) {
      this.deleted = true
      let id = val.rowId

      this.$store.dispatch('company/delete', { id })
      .then(result => {
        console.log('res', result)
        this.$refs.deleteCompany.hide()
        this.$refs.list.fetchData()
        this.submitted = !this.submitted
        this.$bvToast.toast(`${val.name} successfully deleted!`, {
          title: "Notification",
          variant: "success"
        })
        setTimeout(() => {
          this.deleted = false;
        }, 1500)
      })
      .catch(err => {
        this.deleted = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    onActivate (val) {
      let model = val
      this.$bvModal.msgBoxConfirm('Are you sure you want to ' + (model.active ? 'Deactivate' : 'Activate'), {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        if(res == true){
          this.$store.dispatch('company/activate', model)
          .then(res => {
            console.log('res', res)
            this.$refs.list.fetchData()
            this.$bvToast.toast(`Company ${model.name} has been ${!model.active ? 'Activated' : 'Deactivated'}!`, {
              title: 'Notification',
              variant:'success'
            })
          })
          .catch(err => error.errorHandler(err, this.$bvToast))
        }
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
    toggleFilter(e) {
      let filterButton = this.$refs['filterButton'],
        children = filterButton.children
      this.type = e.target.value
      for(var key in children){
        if(typeof children[key] == 'object'){
          children[key].classList.add('btn-white-primary')
          children[key].classList.remove('btn-primary')
        }
      }

      if(e.target){
        e.target.classList.add('btn-primary')
        e.target.classList.remove('btn-white-primary')
      }

      if(this.$refs['list'])
        this.$refs['list'].fetchData(false, e.target ? e.target.value : 'active', false)
    },
  },
  mounted(){
    this.toggleFilter({
      target:this.$refs['filterButton'].children[_types[this.$route.query.type || 'active']]
    })
  }
}
</script>

<style lang="scss">
  .modalBodyContainer {
    background: #e8eaee;
    overflow: auto;
    height: 80vh;
  }
</style>